export default __webpack_public_path__ + "static/media/arrow.fc872b00.png";